import { createTheme } from '@mui/material/styles';

// assets
import colors from 'assets/scss/_themes-vars.module.scss';

// project imports
import componentStyleOverrides from './compStyleOverride';
import themePalette from './palette';
import themeTypography from './typography';
import { ptBR } from '@mui/x-date-pickers';


export const theme = () => {
    const color = colors;

    const themeOption = {
        colors: color,
        heading: color.primaryDark,
        paper: color.paper,
        backgroundDefault: color.paper,
        background: color.primaryLight,
        darkTextPrimary: color.primaryDark,
        darkTextSecondary: color.grey500,
        textDark: color.primaryDark,
        menuSelected: color.secondaryDark,
        menuSelectedBack: color.secondaryLight,
        divider: color.grey200,
    };

    const themeOptions = {
        direction: 'ltr',
        palette: themePalette(themeOption),
        mixins: {
            toolbar: {
                minHeight: '48px',
                padding: '16px',
                '@media (min-width: 600px)': {
                    minHeight: '48px'
                }
            }
        },
        ptBR,
        typography: themeTypography(themeOption)
    };

    const themes = createTheme(themeOptions, ptBR);
    themes.components = componentStyleOverrides(themeOption);
    themes.colors = color;

    return themes;
};

export default theme;
